<div id="id_{{component.id}}" class="dynamic-renderer"></div>